import { useEffect, useState, createContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams } from "react-router-dom";
import Loading from "../Loading/Loading";

export const TokenContext = createContext(null);

function AuthWrapper({ returnTo, children }) {
  const { isLoading, isAuthenticated, loginWithRedirect, getAccessTokenSilently } = useAuth0();
  const params = useParams();
  const [token, setToken] = useState();

  const isPuppeteer = typeof window !== "undefined" && window.__puppeteerAuth;

  useEffect(() => {
    async function fetchToken() {
      try {
        const accessToken = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        });
        setToken(accessToken);
      } catch (error) {
        const err = error?.error || error?.message || "";
        if (err !== "login_required" && err !== "Login required") {
          console.error("AuthWrapper fetchToken - unexpected error:", error);
        }
      }
    }

    if (isPuppeteer) {
      const puppeteerToken = localStorage.getItem("auth_token") || sessionStorage.getItem("auth_token");
      if (puppeteerToken) {
        setToken(puppeteerToken);
        return;
      }
    }

    if (!isLoading && !isAuthenticated) {
      const redirectUrl = `${returnTo}/${Object.values(params).join("/")}`;
      loginWithRedirect({
        appState: { returnTo: redirectUrl },
      });
    } else if (!token && !isPuppeteer) {
      fetchToken();
    }
  }, [token, isLoading, isAuthenticated, getAccessTokenSilently, loginWithRedirect, params, returnTo, isPuppeteer]);

  if (isLoading && !token) {
    return <Loading />;
  }

  if (token) {
    return <TokenContext.Provider value={token}>{children}</TokenContext.Provider>;
  }

  return null;
}

export default AuthWrapper;